import type { MaxDiffBlockModel } from '@webapp/common/resources/entities';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class MaxDiffApi extends QuestionSimpleApi {
    public change(q: QuestionContext, evt: ResponseEventParams): void {
        const { value } = evt;
        const { responseActor, id } = q;
        responseActor.send({ type: 'CHANGE', value, questionId: id });
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { maxDiffBlocksActor, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        let blocks: MaxDiffBlockModel = [],
            answers: Record<
                number,
                {
                    best: number | null;
                    worst: number | null;
                }
            > = {};

        if (maxDiffBlocksActor) {
            ({ answers, blocks } = maxDiffBlocksActor.getSnapshot().context);
        }
        const data = blocks.flatMap((block, idx) =>
            block.map((blockItem) => {
                const isWorst = answers[idx]?.worst === blockItem.answerId;
                const isBest = answers[idx]?.best === blockItem.answerId;
                return {
                    answer: blockItem.answerId,
                    int: idx + 1,
                    bool: isWorst ? false : isBest ? true : null,
                };
            }),
        );
        return {
            question: id,
            data,
            comment,
        };
    }

    public validate(q: QuestionContext): boolean {
        const maxDiffBlocksActor = q.maxDiffBlocksActor;
        if (!maxDiffBlocksActor) return false;
        const {
            params: { required },
        } = q;
        const { answers, blocks } = maxDiffBlocksActor.getSnapshot().context;

        if (!required) return true;

        return blocks.every((block, idx) => answers[idx] && answers[idx].best && answers[idx].worst);
    }
}
